export class SideNavTextDataEN {
    static readonly htmlLabel = {
        appName: 'PREP',

    };
    static readonly snackbarLabel = {

    };
    static readonly tooltipLabel = {
        userProfileText: 'Profile',
        userLogoutText: 'Sign out',

    }
    static readonly menuLabel = {

        menuDashboard: 'Dashboard',
        menuUploadFile: 'Upload File',
        menuExport: 'Exports',
        menuReport: 'Reports',
        menuHeaderAdminTool: 'ADMIN TOOL',
        menuFileUploadUsage: 'File Upload Usage',
        menuAPIUsage: 'API Usage',
        menuAccountConfig: 'Account Config',
        menuTemplateConfig: 'Template Config',
        menuExternalUsage: 'External Usage',
        menuHeaderCEAdmin: 'CE ADMIN',
        menuHeaderCanvasIntegration: 'CANVAS INTEGRATION',
        menuCanvasLMSFiles: 'Canvas LMS Files',
        menuHeaderCivicPlusIntegration: 'CIVIC PLUS INTEGRATION',
        menuCivicPlusFiles: 'CivicPlus Files',
        MenuHeaderRemediationServices: 'REMEDIATION SERVICES',
        menuOrder: 'Orders',
        menuTransactions: 'Transactions',
        MenuHeaderD2lIntegration: 'D2L INTEGRATION',
        menuD2lLMSFiles: 'D2L LMS Files',
        MenuHeaderRSPAdministration: 'RSP SERVICE ADMIN',
        menuCEOrders: 'CE Orders',
        menuUsageDashboard: 'Usage Dashboard',
        manueManageReport: 'Manage Report',
        menuUsers: 'Users',
        menuCEUserNotificationUser: 'CE User Notification',
        menuExternalContact: 'External Contact'
    };
}
